import React from 'react';

const openSection = (id) => {
    const DOMTarget = document.querySelector(`#${id}:not(.expanded) header button`);
    if (DOMTarget) {
        DOMTarget.click();
    }
};

const scrollToFirstError = (id) => {
    setTimeout(() => {
        // first error
        let el = document.querySelector('.input-error-message');
        if (!el) {
            el = document.getElementById(id);
        }
        if (el) {
            el.scrollIntoView({block: 'center', behavior: 'smooth'});
        }
    });
};

class SurveyEditorErrorScroller extends React.PureComponent {
    componentDidUpdate(prevProps) {
        const {errors, isSubmitting, isValidating} = this.props;
        if (errors !== prevProps.errors || isSubmitting !== prevProps.isSubmitting || isValidating !== prevProps.isValidating) {
            if (!isSubmitting && prevProps.isSubmitting && !isValidating && errors && Object.keys(errors).length > 0) {
                for (const key of Object.getOwnPropertyNames(errors)) {
                    if (errors[key]) {
                        switch (key) {
                            case 'editor':
                                if (errors.editor.pages) {
                                    const pages = Object.keys(errors.editor.pages);
                                    for (const page of pages) {
                                        if (errors.editor.pages[page]) {
                                            openSection(`survey-editor-item-${page}`);
                                        }
                                    }
                                }
                                break;
                            case 'parameters':
                            case 'extraFields':
                                openSection('survey-editor-item-extraParameters');
                                break;
                            case 'trackerUrl':
                            case 'sendProvider':
                            case 'sendProviderParams':
                            case 'trackerArchiveFrequency':
                            case 'trackerArchiveFrequencyValue':
                                openSection('survey-editor-item-sending');
                                break;
                            case 'cloudEventsEnabled':
                            case 'cloudEventsSettings':
                            case 'alerts':
                                openSection('survey-editor-item-events');
                                break;
                            case 'consoleButtons':
                                openSection('survey-editor-item-consoleSettings');
                                break;
                            default:
                                openSection('survey-editor-item-settings');
                        }
                    }
                }
                scrollToFirstError();
            }
        }
    }

    render() {
        return null;
    }
}

export default SurveyEditorErrorScroller;
